export default __webpack_public_path__ + "static/media/nonewnotification.4b3ec2c9.jpg";